import clsx from "clsx";
import { useEffect, useState } from "react";
import { useLoader } from "@/app/hooks/useLoader";
import { useRouter } from "@/app/hooks/useRouter";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { ICBLstatsBodyprops } from "@/api_framework/api_modals/CBL";
import { useCBLListAPI } from "@/app/hooks/api_hooks/PWL/useCBLListAPI";
import TableSkeletonComponent from "@/app/components/ui/LoaderComponent";
import { IPatientWaitingListState } from "@/app_redux/reducers/slices/auth/patient_waiting_list_slice";

const CBLStatsComponent = () => {
  const { getRouteKey } = useRouter();
  const { routeState } = useRouteInfo(getRouteKey("PATIENT_WAITING_LIST", "id"));
  const { CBLStats, CBLFilters } = routeState.state as IPatientWaitingListState;
  const fetcCBLList = useCBLListAPI();
  const [currentStat, setCurrentStat] = useState<string>("on_hold");
  const isStatsLoading = useLoader("isPWLStatsFetchInProgress");

  const handleClick = (key: string) => {
    setCurrentStat(key);
    const constructedData: ICBLstatsBodyprops = {
      booking_date: CBLFilters.booking_date,
      created_date: CBLFilters.created_date,
      clinic_details: {
        id: CBLFilters.clinic_details?.id,
      },
      service_details: {
        id: CBLFilters.service_details?.id,
      },
      sub_service_details: {
        id: CBLFilters.sub_service_details?.id,
      },
      created_by: {
        id: CBLFilters.created_by?.id,
      },
    };
    fetcCBLList(constructedData, key);
  };

  useEffect(() => {
    setCurrentStat("on_hold");
  }, [CBLFilters]);

  return (
    <div className="overflow-x-auto overflow-y-hidden flex gap-4 py-2">
      {!isStatsLoading ? (
        <div className="flex gap-4 w-full">
          {CBLStats &&
            Object.keys(CBLStats)?.map((key: string, id: number) => (
              <div
                key={id}
                className={clsx(
                  "w-auto sm:w-44 py-0 sm:py-4 px-4 flex flex-col text-[10px] sm:text-sm md:text-xs xl:text-sm rounded-lg bg-white border cursor-pointer",
                  currentStat.toLowerCase() === key.toLowerCase() ? "border-[#0068FF]" : "border-gray-300",
                )}
                onClick={() => handleClick(key)}
              >
                <div className="text flex-col items-start p-2 sm:p-0 gap-1 whitespace-nowrap">
                  <h3
                    className={clsx(
                      "text-[10px] sm:text-xs 2xl:text-base font-semibold",
                      currentStat.toLowerCase() === key.toLowerCase() ? "text-[#0068FF]" : "text-black",
                    )}
                  >
                    {CBLStats[key]}
                  </h3>
                  <p className="text-black text-[8px] sm:text-xs 2xl:text-sm md:text-xs font-medium capitalize">
                    {key.replace("_", " ")}
                  </p>
                </div>
              </div>
            ))}
        </div>
      ) : (
        <TableSkeletonComponent
          columnLength={4}
          rowLength={2}
          bodyLength={4}
          containerClassName="mt-0 h-fit w-full overflow-hidden rounded-lg border border-[#ECECEC]"
        />
      )}
    </div>
  );
};

export default CBLStatsComponent;
